import { action, CubePresenter, FlipIntent, Logger } from 'wdc-cube'

import { WaitingScope } from 'src/components/waiting/waiting.scopes'
import { MainPresenter } from 'src/main/Main.presenter'
import { StatusProcessamentoKeys } from '.'
import BorderoKeys from '../bordero.keys'
import borderoService from '../bordero.service'
import StatusProcessamentoScope from './status_processamento.scopes'

const LOG = Logger.get('StatusProcessamentoPresenter')

export class StatusProcessamentoPresenter extends CubePresenter<MainPresenter, StatusProcessamentoScope> {
    // :: Constructor
    public constructor(app: MainPresenter) {
        super(app, new StatusProcessamentoScope())
    }

    // :: Instance
    #borderoId?: number

    public override release() {
        super.release()
        LOG.debug('Finalized')
    }

    public override async applyParameters(intent: FlipIntent, initialization: boolean): Promise<boolean> {
        const keys = new StatusProcessamentoKeys(this.app, intent)

        keys.dialogSlot(this.scope)

        LOG.debug(`applyParameters ${keys.borderoId}`)

        if (initialization) {
            await this.#initialize()
        }
        if (this.#borderoId !== keys.borderoId) {
            await this._loadResults(keys.borderoId)
        }

        return keys.allow
    }

    public override publishParameters(intent: FlipIntent): void {
        const keys = new StatusProcessamentoKeys(this.app, intent)
        keys.borderoId = this.#borderoId

        LOG.debug(`publishParameters ${keys.borderoId}`)
    }

    async #initialize() {
        LOG.debug('initialize')

        this.scope.onClose = this.handleClose.bind(this)
        this.scope.onFind = this.handleFind.bind(this)
    }

    @action()
    private async handleClose() {
        await new BorderoKeys(this.app).flip()
    }

    @action()
    private async handleFind(filterValue: string) {
        try {
            this.scope.waiting = new WaitingScope()

            if (!this.#borderoId) throw new Error('Id do borderô deve ser informado')

            LOG.debug(`handleFind with filter: ${filterValue}`)

            const resultados = await borderoService.fetchStatusProcessamentoBordero(this.#borderoId)

            this.scope.resultados = !filterValue
                ? resultados
                : resultados.filter(
                      (item) =>
                          item.etapa.toLowerCase().includes(filterValue.toLowerCase()) ||
                          item.status.toLowerCase().includes(filterValue.toLowerCase()) ||
                          item.ref.toLowerCase().includes(filterValue.toLowerCase())
                  )
        } catch (caught) {
            LOG.error('handleFind', caught)
            throw caught
        } finally {
            this.scope.waiting = undefined
        }
    }

    private async _loadResults(borderoId?: number) {
        if (!borderoId) throw new Error('Id do borderô deve ser informado')

        this.#borderoId = borderoId

        this.handleFind('').catch(LOG.caught)
    }
}

export default StatusProcessamentoPresenter
